/** Farben der Muskel-Stufen (F-34 C2) - nur Verweise auf die zentralen Tokens (Leitlinie 7). */
import type { MuskelStatus } from '@/domain/training/muskelcheck';
import type { ErholungsStufe } from '@/domain/training/regeneration';
import type { Rang } from '@/domain/training/rang';

export const STATUS_FARBE: Record<MuskelStatus, string> = {
  nicht: 'var(--color-muskel-nicht)',
  deutlich_unter: 'var(--color-muskel-deutlich-unter)',
  knapp_unter: 'var(--color-muskel-knapp-unter)',
  im_ziel: 'var(--color-muskel-im-ziel)',
  ueber: 'var(--color-muskel-ueber)',
};

export const ERHOLUNG_FARBE: Record<ErholungsStufe, string> = {
  frisch: 'var(--color-erholung-frisch)',
  teilweise: 'var(--color-erholung-teilweise)',
  erholt: 'var(--color-erholung-erholt)',
};

export const RANG_FARBE: Record<Rang, string> = {
  bronze: 'var(--color-rang-bronze)',
  silber: 'var(--color-rang-silber)',
  gold: 'var(--color-rang-gold)',
  platin: 'var(--color-rang-platin)',
  diamant: 'var(--color-rang-diamant)',
};
